import React, { Component } from 'react';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Section, Grid, Cell } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import './Press.module.css';

const PressRelease = DisplayComponent(
  class PressRelease extends Component {
    render() {
      const {
        title,
        subtitle,
        location,
        date,
        content,
        boilerplate,
        contact_info,
        classes
      } = this.props;

      let preamble = '';
      if (location) {
        preamble = location + ', ';
      }
      if (date) {
        preamble += date;
      }

      let modContent = content;
      modContent = content.replace(
        '<p>',
        '<p><strong>' + preamble + '</strong> – '
      );

      return (
        <Section>
          <div styleName="release-section">
            <Grid direction="x" primaryAlignment="align-center">
              <Cell smallSize="20" mediumSize="20" largeSize="20">
                <span styleName="date eyebrow">{date}</span>
                <Header level={1} displayAs={1}>
                  {title}
                </Header>
                {subtitle && (
                  <p>
                    <em>{subtitle}</em>
                  </p>
                )}
                <div
                  dangerouslySetInnerHTML={{ __html: modContent }}
                  className={classes}
                />

                <div dangerouslySetInnerHTML={{ __html: boilerplate }} />
                <div dangerouslySetInnerHTML={{ __html: contact_info }} />
              </Cell>
            </Grid>
          </div>
        </Section>
      );
    }
  }
);

export default PressRelease;
